var CheckoutControlsConfig = {

    data: [],

    set: function (d) {
        var self = this;
        self.data = d;
    },

    getDataByControllerName: function (controllerName) {
        var self = this;

        var d = {};
        $(self.data).each(function (i, item) {
            if (item.ControllerName === controllerName)
                d = item;
        });

        return d;
    }
};

var ControlInitiator = {

    init: function (obj) {
        var self = this;

        var $item = $(obj);

        var controllerName = $item.attr("ng-controller");
        
        var itemId = $item.attr('id');
        
        obj.events = [
            'dataload',
            'dataloaderror',
            'htmlload',
            'htmlloaderror',
            'templateload',
            'templateloaderror'
        ];

        obj.binders = $.Enumerable.Empty().ToDictionary();
        if (obj.binders) {
            obj.binders.Add('dataload', []);
            obj.binders.Add('dataloaderror', []);
            obj.binders.Add('htmlload', []);
            obj.binders.Add('htmlloaderror', []);
            obj.binders.Add('templateload', []);
            obj.binders.Add('templateloaderror', []);
        }

        obj.bind = function(event, fn) {
            obj.binders.Get(event).push(fn);
        };

        obj.unbind = function(event) {
			//https://stackoverflow.com/questions/1232040/how-do-i-empty-an-array-in-javascript
            obj.binders.Get(event).length = 0;
        };

        obj.trigger = function(event, args) {
            var array = obj.binders.Get(event);
            $(array).each(function(i, item) {
                if (typeof(item) == 'function')
                    item.apply(null, args);
            });
        };

        obj.data = CheckoutControlsConfig.getDataByControllerName(controllerName);
        
        obj.focus = function () {

        };

        obj.getCheckoutData = function (endpoint, data, onSuccess, onError) {

            var internalData = {
                data: JSON.stringify(data)
            };

            $.ajax({
                async: false,
                type: 'POST',
                dataType: 'json',
                contentType: 'application/json; charset=UTF-8',
                ContentType: 'application/json; charset=UTF-8',
                url: LhApp.Function.Url.getServiceEndpoint('checkoutservice.svc/' + endpoint),
                data: JSON.stringify(internalData),
                success: function (response) {
                    obj.template = response.d.tmpl;
                    var parsed = jQuery.parseJSON(response.d.data);

                    obj.trigger('dataload', [obj, parsed]);

                    if (typeof (onSuccess) === 'function')
                        onSuccess(parsed);
                },
                error: function (ex) {
                    if (ex.responseText) {
                        var parsed = jQuery.parseJSON(ex.responseText);

                        obj.trigger('dataloaderror', [obj, parsed]);

                        if (typeof (onError) === 'function')
                            onError(parsed);
                    } else {
                        obj.trigger('dataloaderror', [obj, ex]);

                        if (typeof (onError) === 'function')
                            onError(ex);
                    }

                }
            });

        };

        obj.invokeCheckout = function (data, method, args, onSuccess, onError) {
            var internalData = {
                data: JSON.stringify(data),
                arguments: JSON.stringify(args)
            };

            $.ajax({
                async: false,
                type: 'POST',
                dataType: 'json',
                contentType: 'application/json; charset=UTF-8',
                ContentType: 'application/json; charset=UTF-8',
                url: LhApp.Function.Url.getServiceEndpoint('checkoutservice.svc/' + method),
                data: JSON.stringify(internalData),
                success: function (response) {
                    if (typeof (onSuccess) === 'function')
                        onSuccess(response.d);
                },
                error: function (ex) {
                    if (typeof (onError) === 'function')
                        onError(ex);
                }
            });
        };

    },

    initAll: function () {

        var self = this;

        $('.x-angular-control').each(function (i, item) {
            self.init(item);
        });

    }

};